<template>
  <div class="row">
    <div class="col-12">
      <!-- 위험등록부 목록 -->
      <c-table
        ref="tableRisk"
        title="LBL0001203"
        tableId="riskRegister01"
        :columns="gridRisk.columns"
        :data="riskReduce.riskbooks"
        :merge="gridRisk.merge"
        :gridHeight="setheight"
        :usePaging="false"
      >
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'riskHazardPicture'">
            <q-icon
              class="cursor-pointer"
              size="sm"
              color="blue-6"
              name="image"
              @click.stop="openHazardPicture(props)"
            />
          </template>
          <template v-else-if="col.name === 'picture'">
            <q-icon
              class="cursor-pointer"
              size="sm"
              color="green"
              name="image"
              @click.stop="openImprPicture(props)"
            />
          </template>
          <template v-else-if="col.name === 'customCol'">
            <component
              :is="imprComponent"
              :col="col"
              :props="props"
              :inputEditable="false"
              :requestContentsCols="requestContentsCols"
              tableKey="ramKrasAssessScenarioId"
              ibmTaskTypeCd="ITT0000020"
              ibmTaskUnderTypeCd="ITTU000025"
              @imprChange="imprChange"
            />
          </template>
        </template>
      </c-table>
    </div>
    <div class="col-12">
      <!-- 개선 목록 -->
      <c-table
        ref="tableImpr"
        title="LBL0001174"
        tableId="impr01"
        :columns="gridImpr.columns"
        :data="riskReduce.imprs"
        :merge="gridImpr.merge"
        :gridHeight="setheight"
        :usePaging="false"
        @linkClick="linkClick"
      >
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'riskHazardPicture'">
            <q-icon
              class="cursor-pointer"
              size="sm"
              color="blue-6"
              name="image"
              @click.stop="openHazardPicture(props)"
            />
          </template>
          <template v-else-if="col.name === 'picture'">
            <q-icon
              class="cursor-pointer"
              size="sm"
              color="green"
              name="image"
              @click.stop="openImprPicture(props)"
            />
          </template>
        </template>
        <!-- :highLightInfo="gridImpr.highLightInfo" -->
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "kras-register-TL",
  props: {
    param: {
      type: Object,
      default: function () {
        return {
          ramRiskAssessmentPlanId: "",
          ramStepCd: "",
        };
      },
    },
    height: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      riskReduce: {
        imprs: [],
        riskbooks: [],
      },
      gridRisk: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "groupMdmSopId" },
          { index: 2, colName: "riskHazardName" },
          { index: 3, colName: "riskHazardName" },
          { index: 4, colName: "riskHazardName" },
        ],
        columns: [
          {
            name: "processName",
            field: "processName",
            // 공정
            label: "LBLPROCESS",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "작업순서",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "riskHazardPicture",
            field: "riskHazardPicture",
            // 사진
            label: "LBL0001175",
            align: "center",
            style: "width:40px",
            sortable: false,
            type: "custom",
          },
          {
            name: "riskHazardName",
            field: "riskHazardName",
            // 분류-유해위험요인
            label: "LBL0001020",
            align: "left",
            style: "width:250px",
            sortable: false,
          },
          {
            name: "relationLaw",
            field: "relationLaw",
            // 관련법규
            label: "LBL0001021",
            align: "left",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "riskOccurrenceCause",
            field: "riskOccurrenceCause",
            // 원인
            label: "LBL0001006",
            align: "left",
            style: "width:200px",
            sortable: false,
          },
          {
            name: "riskOccurrenceResult",
            field: "riskOccurrenceResult",
            // 결과
            label: "LBL0001007",
            align: "left",
            style: "width:200px",
            sortable: false,
          },
          {
            name: "currentSafetyMeasures",
            field: "currentSafetyMeasures",
            // 현재안전조치
            label: "LBL0001025",
            align: "left",
            style: "width:150px",
            sortable: false,
          },

          {
            name: "before",
            field: "before",
            // 개선전
            label: "LBL0001008",
            align: "center",
            child: [
              {
                name: "beforeFrequency",
                field: "beforeFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeStrength",
                field: "beforeStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeRisk",
                field: "beforeRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          {
            name: "picture",
            field: "picture",
            // 개선<br/>전/후<br/>사진
            label: "개선 전/후 사진",
            align: "center",
            type: "custom",
            style: "width:70px",
            sortable: false,
          },
          {
            name: "improvementMeasures",
            field: "improvementMeasures",
            // 추가 리스크관리 계획
            label: "LBL0001122",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "customCol",
            field: "customCol",
            label: "LBLIMPRNO_PROGRESS",
            align: "center",
            style: "width:150px",
            type: "custom",
            sortable: false,
          },
          {
            name: "after",
            field: "after",
            // 개선후
            label: "LBL0001012",
            align: "center",
            child: [
              {
                name: "afterFrequency",
                field: "afterFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterStrength",
                field: "afterStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterRisk",
                field: "afterRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          {
            name: "assessDate",
            field: "assessDate",
            // 평가일
            label: "LBL0001013",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "assessUserName",
            field: "assessUserName",
            // 평가자
            label: "LBL0001014",
            align: "center",
            style: "width:80px",
            sortable: false,
          },
        ],
        height: "500px",
      },
      gridImpr: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "groupMdmSopId" },
          { index: 2, colName: "riskHazardName" },
          { index: 3, colName: "riskHazardName" },
          { index: 4, colName: "riskOccurrenceCause" },
          { index: 5, colName: "riskOccurrenceCause" },
          { index: 6, colName: "riskOccurrenceCause" },
          { index: 7, colName: "riskOccurrenceCause" },
          { index: 8, colName: "riskOccurrenceCause" },
        ],
        columns: [],
        data: [],
        highLightInfo: {
          val: "scenarioId",
          ids: [],
        },
        height: "500px",
      },
      imprComponent: () => import(`${"@/pages/common/ibm/tableImpr.vue"}`),
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "80%",
        param: {},
        closeCallback: null,
      },
      requestImprRow: null,
      imprData: null,
      editable: true,
      listUrl: "",
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    setheight() {
      let pxRemove = this.height.replace("px", "");
      return this.height && this.height.indexOf("px") > -1 && !isNaN(pxRemove)
        ? Number(pxRemove) - 20 + "px"
        : "500px";
    },
    requestContentsCols() {
      return ["riskHazardNameClass", "riskOccurrenceCause"];
    },
  },
  methods: {
    init() {
      // role setting
      // url setting
      this.listUrl = selectConfig.ram.kras.riskReduce.list.url;
      // code setting
      this.$comm.getStepItems("IBM_STEP_CD").then((_result) => {
        this.gridImpr.columns = [
          {
            name: "processName",
            field: "processName",
            // 공정
            label: "LBLPROCESS",
            align: "center",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "작업순서",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "riskHazardPicture",
            field: "riskHazardPicture",
            // 사진
            label: "LBL0001175",
            align: "center",
            style: "width:40px",
            sortable: false,
            type: "custom",
          },
          {
            name: "riskHazardName",
            field: "riskHazardName",
            // 분류-유해위험요인
            label: "LBL0001020",
            align: "left",
            style: "width:250px",
            sortable: false,
          },
          {
            name: "riskOccurrenceCause",
            field: "riskOccurrenceCause",
            // 원인
            label: "LBL0001006",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "riskOccurrenceResult",
            field: "riskOccurrenceResult",
            // 결과
            label: "LBL0001007",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "currentSafetyMeasures",
            field: "currentSafetyMeasures",
            // 현재안전조치
            label: "LBL0001025",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "picture",
            field: "picture",
            // 개선<br/>전/후<br/>사진
            label: "개선 전/후 사진",
            align: "center",
            type: "custom",
            style: "width:70px",
            sortable: false,
          },
          {
            name: "improvementMeasures",
            field: "improvementMeasures",
            // 추가 리스크관리 계획
            label: "LBL0001122",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "ibmTitle",
            field: "ibmTitle",
            // 제목
            label: "LBLTITLE",
            align: "left",
            type: "link",
            style: "width:300px",
            sortable: true,
          },
          {
            name: "ibmStepCd",
            field: "ibmStepCd",
            // 진행상태
            label: "LBLPROGRESS",
            align: "center",
            style: "width:100px",
            type: "tag",
            colorItems: _result,
            sortable: false,
          },

          {
            name: "improveRequest",
            field: "improveRequest",
            // 요청부서정보
            label: "요청부서정보",
            align: "center",
            style: "width:250px",
            sortable: true,
          },
          {
            name: "actionCompleteRequestDate",
            field: "actionCompleteRequestDate",
            // 조치완료요청일
            label: "LBL0001017",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "actionDeptName",
            field: "actionDeptName",
            // 조치부서
            label: "LBL0001018",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
        ];
      });
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = {
        ramRiskAssessmentPlanId: this.param.ramRiskAssessmentPlanId,
      };
      this.$http.request((_result) => {
        this.$_.extend(this.riskReduce, _result.data);
      });
    },
    imprChange() {
      this.$refs["tableRisk"].$refs["compo-table"].resetVirtualScroll();
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.imprData = row;
      this.popupOptions.title = "LBLIMPROVE";
      this.popupOptions.param = {
        sopImprovementId: row.sopImprovementId,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        this.$_.extend(this.imprData, result.col1);
        this.$refs["tableImpr"].$refs["compo-table"].resetVirtualScroll();
      }
    },
    openHazardPicture(props) {
      this.popupOptions.title = "LBL0001110"; // 유해위험요인 사진
      this.popupOptions.param = {
        ramRiskHazardId: props.row.ramRiskHazardId,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/common/hazard/riskHazardPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeHazardPicturePopup;
    },
    closeHazardPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    openImprPicture(props) {
      this.popupOptions.title = "LBL0001181"; // 개선 사진
      this.popupOptions.param = {
        ramKrasAssessScenarioId: props.row.ramKrasAssessScenarioId,
        sopImprovementIds: props.row.sopImprovementIds,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/kras/action/krasScenarioImprPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeScenarioImprPicturePopup;
    },
    closeScenarioImprPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  },
};
</script>
